/*eslint angular/controller-as: 0*/
(function() {
    angular
        .module('emarket.commons')
        .controller('CustomFieldController', ['$log', '$scope', '$mdDialog', '$mdMedia', function($log,
            $scope,
            $mdDialog,
            $mdMedia) {
            var vm = this;
            var isMobile = $mdMedia('xs') || $mdMedia('sm');
            var spanSizeCount = 4;
            vm.range = {
                field1: '',
                field2: ''
            };
            vm.getExtraSpace = function(field) {
                var list = field.values.length;
                if (field.extraText) {
                    list += 1;
                }
                var size = spanSizeCount - list;
                size = size > 0 ? size : 0;
                return new Array(size);
            };
            vm.defaultValue = function(field) {
                if (field.dataType === 'number') {
                    $scope.ngModel = '+3';
                } else {
                    $scope.ngModel = null;
                }
            };
            var watchEvent;
            if ($scope.field.showAs === 'range') {
                watchEvent = $scope.$watch(function() {
                    return vm.range;
                },
                function() {
                    if (vm.range.field1 || vm.range.field2) {
                        $scope.ngModel = vm.range.field1 + '--' + vm.range.field2;
                    }
                    if (isMobile) {
                        if ($scope.ngModel) {
                            vm.hideDialog = true;
                        } else {
                            vm.hideDialog = false;
                        }
                    }
                },
                true);
            }
            var rangeWatchEvent = $scope.$watch(function() {
                return $scope.ngModel;
            },
            function() {
                switch ($scope.field.showAs) {
                case 'range': {
                    if ($scope.edit) {
                        return;
                    }
                    if (!$scope.ngModel) {
                        vm.range.field1 = '';
                        vm.range.field2 = '';
                        return;
                    }
                    var range = $scope.ngModel.toString().split('--');

                    if (range[0]) {
                        vm.range.field1 = range[0];
                    }
                    if (range[1]) {
                        vm.range.field2 = range[1];
                    }
                    break;
                }
                }
                if (isMobile) {
                    if ($scope.ngModel) {
                        vm.hideDialog = true;
                    } else {
                        vm.hideDialog = false;
                    }
                }
            },
            true);
            vm.showDialog = function() {
                $mdDialog
                    .show({
                        templateUrl: 'directives/custom-fields/types/dialog.tpl.html',
                        controller: 'CustomFieldDialogController as vm',
                        locals: {
                            field: $scope.field
                        },
                        clickOutsideToClose: true
                    })
                    .then(function(selectedValue) {
                        if (selectedValue) {
                            $scope.ngModel = selectedValue;
                        }
                        vm.onExpressionHandler(null, $scope.field, selectedValue);
                    });
            };
            var expressionHandler = $scope.onChange();
            vm.onExpressionHandler = function() {
                expressionHandler.apply(null, arguments);
            };

            $scope.$on('$destroy', function() {
                if (watchEvent) {
                    watchEvent();
                }
                rangeWatchEvent();
            });
        }]);
}());
